// extracted by mini-css-extract-plugin
export var link = "_t3-0";